const SearchResultsModel = function (options) {
  "use strict";
  this.data = options.data;
  this.getData = function () {
    return this.data;
  };
};

export { SearchResultsModel };



// WEBPACK FOOTER //
// ./srp/models/search_results.js